import { useEffect } from 'react';

const usePreloadImages = (media) => {
	useEffect(() => {
		if (!media || media.length === 0) return;
		media.forEach((item) => {
			if (item.type !== 'video' && item.link) {
				const img = new Image();
				img.src = item.link;
			}
		});
	}, [media]);
};

export default usePreloadImages;
